import { styled } from '../jss-style';
import radioStyle from './radio';

const useRadioStyle = styled(radioStyle, 'radio');
export { radioStyle, useRadioStyle };
export default useRadioStyle;
